import { render, staticRenderFns } from "./DriversVehicleInspectionDatesCreate.vue?vue&type=template&id=88f87564&scoped=true&"
import script from "./DriversVehicleInspectionDatesCreate.vue?vue&type=script&lang=js&"
export * from "./DriversVehicleInspectionDatesCreate.vue?vue&type=script&lang=js&"
import style0 from "./DriversVehicleInspectionDatesCreate.vue?vue&type=style&index=0&id=88f87564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f87564",
  null
  
)

export default component.exports